import React from "react";
import { useNavigate } from "react-router-dom";
import RequestsTable from "../components/RequestsTable";


const Requests: React.FC = () => {
  const navigate = useNavigate();


  return (
    <div className="App">
      <div className="white-back">
        <RequestsTable/>
      </div>
    </div>
  );
};

export default Requests;
